export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./accept-lead-modal.vue?vue&type=template&id=fdc4bd5e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/accept-lead-modal.vue?vue&type=template&id=fdc4bd5e&
// module id = 1713
// module chunks = 0